<template>
  <div>
    <jumbotron
      :bg-img="post.image.url"
      bg-position="center">
      <h1>{{post.title}}</h1>
      <span>Published: {{ post.datePublished | formatDate( 'PPpp') }}</span>
    </jumbotron>
    <div class="container padding-top--lv6">
      <div v-html="post.content"></div>
    </div>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import RouteGetters from '@/mixins/RouteGetters'
import Jumbotron from '@/views/components/Jumbotron'
import Prism from 'prismjs'

export default {
  mixins: [RouteGetters],
  components: {
    Jumbotron
  },
  head () {
    return {
      title: this.post.title
    }
  },
  computed: {
    post: get('Blog/currentPost')
  },
  methods: {
    fetchPost: call('Blog/fetchPost')
  },
  mounted () {
    let data = {
      id: this.route.params.id,
      params: {
        '_embed': ''
      }
    }

    this.fetchPost(data)
  },
  watch: {
    post: function () {
      setTimeout(() => Prism.highlightAll(), 100)
    }
  }
}
</script>

<style lang="scss" scoped></style>
